"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LocalTokenStorage = /** @class */ (function () {
    function LocalTokenStorage(tokenKey, refreshKey, expiryKey) {
        if (tokenKey === void 0) { tokenKey = "token"; }
        if (refreshKey === void 0) { refreshKey = "refresh_token"; }
        if (expiryKey === void 0) { expiryKey = "expiration_date"; }
        this.tokenKey = tokenKey;
        this.refreshKey = refreshKey;
        this.expiryKey = expiryKey;
    }
    LocalTokenStorage.prototype.getToken = function () {
        if (this.hasValue(this.tokenKey)) {
            return {
                token: this.getValue(this.tokenKey),
                refreshToken: this.getValue(this.refreshKey),
                expirationDate: new Date(Number(this.getValue(this.expiryKey)))
            };
        }
        else {
            return null;
        }
    };
    LocalTokenStorage.prototype.storeToken = function (token) {
        this.setValue(this.tokenKey, token.token);
        this.setValue(this.refreshKey, token.refreshToken);
        this.setValue(this.expiryKey, token.expirationDate.getTime().toString());
    };
    LocalTokenStorage.prototype.resetToken = function () {
        this.remove(this.tokenKey);
        this.remove(this.refreshKey);
        this.remove(this.expiryKey);
    };
    LocalTokenStorage.prototype.hasValue = function (key) {
        return localStorage.getItem(key) !== null;
    };
    LocalTokenStorage.prototype.getValue = function (key) {
        return localStorage.getItem(key);
    };
    LocalTokenStorage.prototype.setValue = function (key, val) {
        localStorage.setItem(key, val);
    };
    LocalTokenStorage.prototype.remove = function (key) {
        localStorage.removeItem(key);
    };
    return LocalTokenStorage;
}());
exports.LocalTokenStorage = LocalTokenStorage;
